import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";
import { ICampaign, ICampaigns } from "../models/campaigns";

const CAMPAIGN_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Campaign/";

export const createCampaign = (params: ICampaign) => {
  return GlobalAxios.post(CAMPAIGN_ROUTE, params);
};

export const getCampaignById = (id: string) => {
  return GlobalAxios.get<ICampaigns>(CAMPAIGN_ROUTE + id);
};

export const updateCampaign = ({
  id,
  item,
}: {
  id: string;
  item: ICampaign;
}) => {
  return GlobalAxios.put(CAMPAIGN_ROUTE + id, item);
};

export const listCampaigns = () => {
  return GlobalAxios.get<ISelectType[]>(`${CAMPAIGN_ROUTE}list`);
};
